import type { StatusId, ChangeTypeId } from '@app/app';

/**
 * Available status IDs for filtering
 */
export const STATUS_IDS: StatusId[] = [
  'COMING_SOON',
  'PLANNED',
  'ROLLING_OUT',
  'GENERALLY_AVAILABLE',
  'ROLLED_BACK',
];

/**
 * Available change type IDs for filtering
 */
export const CHANGE_TYPE_IDS: ChangeTypeId[] = [
  'IMPROVEMENT',
  'FIX',
  'EXPERIMENT',
  'REMOVED',
  'ANNOUNCEMENT',
];

/**
 * Available impact rating IDs for filtering
 */
export const IMPACT_RATING_IDS = ['HIGH', 'MEDIUM', 'LOW'] as const;
export type ImpactRatingId = (typeof IMPACT_RATING_IDS)[number];

export const IMPACT_RATING_DISPLAY_NAMES: Record<ImpactRatingId, string> = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
};

/**
 * Available contextual tag IDs for filtering — must match backend API values
 */
export const TAG_IDS = [
  'EXPERIMENT',
  'SEASONAL_RELEASE',
  'UI_RELATED',
  'BUG_FIX',
  'PERFORMANCE_IMPROVEMENT',
  'NEW_FEATURE',
  'DEPRECATION_REMOVAL',
  'INTEGRATION_API_CHANGE',
  'PERMISSIONS_ACCESS_CONTROL',
  'AI_RELATED',
] as const;
export type TagId = (typeof TAG_IDS)[number];

export const TAG_DISPLAY_NAMES: Record<TagId, string> = {
  EXPERIMENT: '#Experiment',
  SEASONAL_RELEASE: '#Seasonal-release',
  UI_RELATED: '#UI',
  BUG_FIX: '#Bug-fix',
  PERFORMANCE_IMPROVEMENT: '#Performance',
  NEW_FEATURE: '#New-feature',
  DEPRECATION_REMOVAL: '#Deprecation',
  INTEGRATION_API_CHANGE: '#API-change',
  PERMISSIONS_ACCESS_CONTROL: '#Permissions',
  AI_RELATED: '#AI',
};

export const getTagDisplayName = (tagId: string): string =>
  TAG_DISPLAY_NAMES[tagId as TagId] ?? tagId;
